import _ from "lodash";
import { ifNullOrWhiteSpace, isNullOrWhiteSpace } from "./JarvisCommonService";
import queryString from "query-string";

export const setToken = ({ jAToken, tokenExpirationUtc, force }) => {
  if (jAToken === null || jAToken === undefined) return;
  if (force === null || force === undefined) force = false;
  var userInfo = JSON.parse(localStorage.getItem("userInfo"));
  userInfo = {
    ...userInfo,
    JAToken: jAToken,
    TokenExpirationUtc: tokenExpirationUtc,
  };
  if (force === false) {
    if (userInfo) {
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
    }
  } else {
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
  }
};
export const getToken = () => {
  var userInfo = JSON.parse(localStorage.getItem("userInfo"));
  if (userInfo) return _.get(userInfo, "JAToken");
};

export const getUserInfo = () => {
  return JSON.parse(localStorage.getItem("userInfo"));
};

export const setPrevUsername = (username) => {
  localStorage.setItem("prevUsername", username);
};

export const setJarvisView = ({ name, componentName }) => {
  localStorage.setItem("jarvisView", JSON.stringify({ name, componentName }));
};

/* View 3 is the default view. A browser that saved another choice before View 3 became the default is moved
   to View 3 once - marked by "jarvisViewDefault" - after which the footer switcher works as usual and a view
   picked there is kept. */
const DEFAULT_JARVIS_VIEW = { name: "View 3", componentName: "View3" };
const DEFAULT_JARVIS_VIEW_VERSION = "View3-2026-10-07";

export const getJarvisView = () => {
  try {
    if (localStorage.getItem("jarvisViewDefault") !== DEFAULT_JARVIS_VIEW_VERSION) {
      localStorage.setItem("jarvisView", JSON.stringify(DEFAULT_JARVIS_VIEW));
      localStorage.setItem("jarvisViewDefault", DEFAULT_JARVIS_VIEW_VERSION);
    }
  } catch {
    // Storage unavailable: the fallback below still gives View 3.
  }
  let view = JSON.parse(localStorage.getItem("jarvisView"));
  if (isNullOrWhiteSpace(view?.name))
    view = { ...DEFAULT_JARVIS_VIEW };
  return view;
};

export const getPrevUsername = () => {
  return localStorage.getItem("prevUsername");
};

export const getTokenExpirationUtc = () => {
  var userInfo = JSON.parse(localStorage.getItem("userInfo"));
  if (userInfo) return userInfo.TokenExpirationUtc;
};

export const clearToken = () => {
  localStorage.removeItem("userInfo");
};

export const getLanguage = () => {
  var langInfo = ifNullOrWhiteSpace(
    JSON.parse(localStorage.getItem("selectedLanguage")),
    {}
  );
  const fontName = langInfo?.LangFontName
    ? langInfo?.LangFontName.toLowerCase()
    : "Default";
  langInfo.JarvisFontClass = `Jarvis-Font-${fontName}`;
  if (isNullOrWhiteSpace(langInfo.LangKey)) langInfo.LangKey = "EN";
  return langInfo;
};

export const setCalendar = ({ calendarId, calendarKey, calendarFormat }) => {
  if (isNullOrWhiteSpace(calendarId) || isNullOrWhiteSpace(calendarKey)) return;
  localStorage.setItem(
    "calendar",
    JSON.stringify({ calendarId, calendarKey, calendarFormat })
  );
};

export const getCalendar = () => {
  var { calendarId, calendarKey, calendarFormat } = ifNullOrWhiteSpace(
    JSON.parse(localStorage.getItem("calendar")),
    {}
  );
  return { calendarId, calendarKey, calendarFormat };
};

export const getBvt_Old = () => {
  const queryInfo = queryString.parseUrl(window.location.href);
  return queryInfo?.query?.bvt;
};

export const getQueryValue = (keyName, withUrlDecoding) => {
  withUrlDecoding = ifNullOrWhiteSpace(withUrlDecoding, true);
  const queryInfo = queryString.parseUrl(window.location.href);
  const value = queryInfo?.query?.[keyName];
  if (isNullOrWhiteSpace(value)) return null;
  if (withUrlDecoding) return decodeURIComponent(value);
  return value;
};

export const setSubSystem = ({ systemKey, subSystemId, vtSubSystemId, subSystemKey, subSystemLangDescription }) => {
  let subSystem = {};
  // if (
  //   isNullOrWhiteSpace(subSystemId) === false &&
  //   isNullOrWhiteSpace(vtSubSystemId) === false &&
  //   isNullOrWhiteSpace(subSystemKey) === false
  // )
  subSystem = {
    systemKey,
    subSystemId,
    vtSubSystemId,
    subSystemKey,
    subSystemLangDescription
  };
  localStorage.setItem("subSystem", JSON.stringify(subSystem));
};

export const getSubSystem = () => {
  const queryInfo = queryString.parseUrl(window.location.href);
  const subSystemId = queryInfo?.query?.SSId;
  const vtSubSystemId = queryInfo?.query?.VTSSId;
  const subSystemKey = queryInfo?.query?.SSKey;
  const systemKey = queryInfo?.query?.SKey;
  let subSystemLangDescription = null;
  // localStorage may be empty (e.g. after localStorage.clear() or a first visit via a deep link),
  // in which case getItem returns null and JSON.parse(null) is null — guard against that.
  let localData = null;
  try {
    localData = JSON.parse(localStorage.getItem("subSystem"));
  } catch (e) {
    localData = null;
  }
  if (!isNullOrWhiteSpace(systemKey) && localData?.systemKey === systemKey) {
    subSystemLangDescription = localData.subSystemLangDescription;
  }

  let data = {
    subSystemId,
    vtSubSystemId,
    subSystemKey,
    systemKey,
    subSystemLangDescription
  };
  if (
    isNullOrWhiteSpace(subSystemId) ||
    isNullOrWhiteSpace(vtSubSystemId) ||
    isNullOrWhiteSpace(subSystemKey)
  ) {
    // Fall back to whatever is in storage; if that's also empty keep the query-derived object
    // so callers still receive an object (never null).
    data = localData ?? data;
  }
  return data;
};

// export const clearBvts = (keepLatest) => {
//   let bvts = [];
//   keepLatest = keepLatest ?? true;
//   if (keepLatest === true) bvts.push(getLatestBvtObject());
//   localStorage.setItem("bvts", JSON.stringify(bvts));
// };
// export const getLatestBvtObject = () => {
//   const bvts = JSON.parse(localStorage.getItem("bvts")) ?? [];
//   const orderList = _.orderBy(bvts, ["creationDateTime"], ["desc"]);
//   const last = _.first(orderList);
//   return last;
// };

// export const findBvtBySubSystem = (subSystem) => {
//   const bvts = JSON.parse(localStorage.getItem("bvts")) ?? [];
//   const index = _.findIndex(bvts, (item) => item.selectedSubSystem.subSystemId === subSystem.subSystemId && item.selectedSubSystem.subSystemKey === subSystem.subSystemKey);
//   return bvts[index]?.code;
// };

export const setCompany = ({
  CompanyId,
  VTCompanyId,
  CompanyLangDescription,
  FinancialTermId,
  VTFinancialTermId,
  FinancialTermLangDescription,
}) => {
  let obj = {};
  if (!isNullOrWhiteSpace(CompanyId) && !isNullOrWhiteSpace(VTCompanyId))
    obj = {
      CompanyId,
      VTCompanyId,
      CompanyLangDescription,
    };
  if (
    !isNullOrWhiteSpace(FinancialTermId) &&
    !isNullOrWhiteSpace(VTFinancialTermId)
  ) {
    obj.FinancialTermId = FinancialTermId;
    obj.VTFinancialTermId = VTFinancialTermId;
    obj.FinancialTermLangDescription = FinancialTermLangDescription;
  }

  localStorage.setItem("company", JSON.stringify(obj));
};

export const getCompany = () => {
  const {
    CompanyId,
    VTCompanyId,
    CompanyLangDescription,
    FinancialTermId,
    VTFinancialTermId,
    FinancialTermLangDescription,
  } = ifNullOrWhiteSpace(JSON.parse(localStorage.getItem("company")), {});

  return {
    CompanyId,
    VTCompanyId,
    CompanyLangDescription,
    FinancialTermId,
    VTFinancialTermId,
    FinancialTermLangDescription,
  };
};

export const setPatron = ({ PatronId, Fullname }) => {
  if (_.isNil(PatronId)) return;
  var userInfo = JSON.parse(localStorage.getItem("userInfo"));
  if (userInfo) {
    userInfo = { ...userInfo, PatronId, Fullname };
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
  }
};

export const checkIfNewJarvisVersionReceived = (jarvisVer) => {
  if (isNullOrWhiteSpace(jarvisVer) === true) {
    return false;
  }
  const jarvisVerKey = "jarvisVer";

  const lSJarvisVer = ifNullOrWhiteSpace(
    localStorage.getItem(jarvisVerKey),
    ""
  );
  if (lSJarvisVer.toLowerCase() !== jarvisVer.toLowerCase()) {
    if (isNullOrWhiteSpace(lSJarvisVer)) {
      setJarvisVersion(jarvisVer);
      return false;
    }

    // const jarvisVerLastAlterDateTime = parseInt(ifNullOrWhiteSpace(localStorage.getItem("jarvisVerLastAlterDateTime"), 0));

    // if (jarvisVerLastAlterDateTime === 0) {
    //   const dateTime = new Date().getTime();
    //   localStorage.setItem("jarvisVerLastAlterDateTime", dateTime);
    //   return true;
    // }

    //const getTime = new Date().getTime();
    // if (jarvisVerLastAlterDateTime + 30000 > getTime) return false;
    // localStorage.setItem("jarvisVerLastAlterDateTime", getTime);

    return true;
  }
  return false;
};

export const setJarvisVersion = (jarvisVer) => {
  const jarvisVerKey = "jarvisVer";
  localStorage.setItem(jarvisVerKey, jarvisVer);
};

export const setClient = (client) => {
  localStorage.setItem("client", JSON.stringify(client));
};

export const getClient = () => {
  const client = ifNullOrWhiteSpace(
    JSON.parse(localStorage.getItem("client")),
    {}
  );
  return client;
};

export const setUserLocalSettings = ({ isSideNavOpen = true }) => {
  const userSettings = { isSideNavOpen };
  localStorage.setItem("userLocalSettings", JSON.stringify(userSettings));
};

export const getUserLocalSettings = () => {
  const userSettings = ifNullOrWhiteSpace(
    JSON.parse(localStorage.getItem("userLocalSettings")),
    {}
  );
  return userSettings;
};
